import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=6fb239c2&lang=pug&"
import script from "./ImageEditor.vue?vue&type=script&lang=js&"
export * from "./ImageEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports